import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { DxToolbarItem } from "devextreme-vue/popup";
import { computed, ref } from "vue";
import modalBase from "./modal-base.vue";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";


export default /*#__PURE__*/_defineComponent({
  __name: 'question-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The message text displayed in the modal.
   * @type {string}
   * @required
   */
  messageText: {
    type: String,
    required: true,
  },
  /**
   * The text displayed on the confirm button.
   * @type {string}
   * @required
   */
  confirmButtonText: {
    type: String,
    required: true,
  },
  /**
   * The text displayed on the reject button.
   * @type {string}
   * @required
   */
  rejectButtonText: {
    type: String,
    required: true,
  },
  /**
   * The text displayed on the cancel button (optional).
   * @type {string | undefined}
   */
  cancelButtonText: {
    type: String,
    required: false,
  },
  /**
   * The title or heading associated with the modal.
   * @type {string}
   * @default 'Confirm'
   */
  title: {
    type: String,
    default: "Confirm",
  },
  /**
   * The height of the modal, defined as a CSS value.
   * @type {string}
   * @default '25vh'
   */
  height: {
    type: String,
    default: "25vh",
  },
},
  emits: ["update:modelValue", "confirm", "reject"],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const closeModal = () => {
  showModal.value = false;
};

const onRejectClick = () => {
  closeModal();
  emit("reject");
};

const onConfirmClick = (e: any) => {
  closeModal();
  emit("confirm", e);
};

const confirmButtonOptions = ref({
  text: props.confirmButtonText,
  onClick: onConfirmClick,
});

const rejectButtonOptions = ref({
  text: props.rejectButtonText,
  onClick: onRejectClick,
});

const cancelButtonOptions = ref({
  text: props.cancelButtonText,
  onClick: closeModal,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(modalBase, {
    title: __props.title,
    width: _unref(ModalWidth).Small,
    height: __props.height,
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event))
  }, {
    content: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(props.messageText), 1)
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: confirmButtonOptions.value
      }, null, 8, ["options"]),
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: rejectButtonOptions.value
      }, null, 8, ["options"]),
      (props.cancelButtonText)
        ? (_openBlock(), _createBlock(_unref(DxToolbarItem), {
            key: 0,
            widget: "dxButton",
            toolbar: "bottom",
            location: "after",
            options: cancelButtonOptions.value
          }, null, 8, ["options"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "width", "height", "modelValue"]))
}
}

})